import React, { useState, useEffect } from 'react';
import Logo from '../../assets/images/2025.webp';
import qrLogo from '../../assets/images/qr-icon.svg';
import BackArrow from '../../assets/images/backarrow.svg';
import Swal from 'sweetalert2';
import { BrowserMultiFormatReader } from '@zxing/library';
import { useLocation, useNavigate } from 'react-router-dom';
import { api } from '../../Api';
import beepSound from '../../assets/sound/beep.mp3';

function Scan() {
  const [isScanning, setIsScanning] = useState(false);
  const [scanner, setScanner] = useState(null);
  const [videoElement, setVideoElement] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [scannedQR, setScannedQR] = useState(null);
  const [token, setToken] = useState(null);
  const location = useLocation();
  const { id: acaraId, tgl_acara } = location.state || {};

  const navigate = useNavigate(); // React Router's hook to navigate

  const handleBack = () => {
    navigate(-1); // Goes back to the previous page
  };
  const playBeep = () => {
    const audio = new Audio(beepSound);
    audio.play();
  };

  useEffect(() => {
    if (isScanning && videoElement) {
      const codeReader = new BrowserMultiFormatReader();
      setScanner(codeReader);

      codeReader.decodeFromVideoDevice(null, videoElement, (result, err) => {
        if (result) {
          handleQRCodeScan(result.getText());
        } else if (err && err.name !== 'NotFoundException') {
          // Handle other errors
        }
      });
    }

    return () => {
      if (scanner) {
        scanner.reset();
      }
    };
  }, [isScanning, videoElement]);

  const startScanner = () => {
    setIsScanning(true);
    setErrorMessage('');
    setSuccessMessage('');
  };

  const stopScanner = () => {
    if (scanner) {
      scanner.reset();
    }
    setIsScanning(false);
  };

  const handleQRCodeScan = async (qrData) => {
    if (qrData.endsWith('-FILA')) {
      try {
        const response = await api.get(`/daftar-hadir/${qrData}`);

        if (response.status === 200) {
          const data = response.data.data;

          if (!data || Object.keys(data).length === 0) {
            setErrorMessage('Data tidak ditemukan.');
            stopScanner();
            return;
          }

          playBeep();
          setScannedQR(qrData);
          setToken(token);
          stopScanner();
          handleSubmit(qrData, response.token, data.nama);
        } else {
          setErrorMessage('Data tidak ditemukan.');
          stopScanner();
        }
      } catch (error) {
        console.error('QR code data is invalid:', error);
        setErrorMessage('Terjadi kesalahan saat mengambil data.');
        stopScanner();
      }
    } else {
      setErrorMessage(
        'QR Code tidak valid. Silahkan scan QR Code dari Filadelfia Blessing Family'
      );
      stopScanner();
    }
  };

  const handleSubmit = async (qr, token, nama) => {
    stopScanner();
    Swal.fire({
      title: 'Proses Absensi. Mohon Tunggu...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const response = await api.post(
        '/submithadir',
        {
          unique_qr: qr,
          acara_id: acaraId,
          tgl_acara: tgl_acara,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // ✅ Just close the loading without showing success alert
      Swal.close();
      setScannedQR(null);
      setErrorMessage('');
      setSuccessMessage(
        'Scan Berhasil<br>Halo ' +
          nama +
          ', Welcome to Filadelfia Blessing Family'
      );
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Terjadi Kesalahan, silahkan coba lagi.',
        confirmButtonColor: '#0185c6',
      });
    }
  };

  return (
    <div className="login-page">
      <img src={Logo} alt="Filadelfia Blessing Family" className="logo" />
      {successMessage && (
        <p
        style={{color:'#0185c6',fontWeight:'500'}}
          className="success-message"
          dangerouslySetInnerHTML={{ __html: successMessage }}
        />
      )}
      {errorMessage && <p className="error-message">{errorMessage}</p>}
      {!isScanning && (
        <div>
          <button className="qr-scan-btn" onClick={startScanner}>
            <img src={qrLogo} alt="QR Code" />
            <span>Scan QR CODE FILA</span>
          </button>
          <button className="qr-scan-btn" onClick={handleBack}>
            <img style={{ width: '15px' }} src={BackArrow} alt="Back" />
            <span style={{ fontSize: '17px' }}>Back to Home</span>
          </button>
        </div>
      )}

      {isScanning && (
        <div>
          <video
            ref={(el) => setVideoElement(el)}
            style={{ width: '100%', height: '265px', objectFit: 'cover' }}
            id="video"
            autoPlay
            muted
          ></video>
          <button className="qr-scan-btn" onClick={stopScanner}>
            Stop Scanning
          </button>
        </div>
      )}
    </div>
  );
}

export default Scan;
